import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  AbstractMenuProvider,
  PartialMenuSection,
} from '../menu-provider.model';
import { ExternalLinkMenuItemModel } from '../menu-item/models/external-link.model';

/**
 * Menu provider for a \"Policy\" external link in the public navbar.
 */
@Injectable()
export class PolicyMenuProvider extends AbstractMenuProvider {

  public getSections(): Observable<PartialMenuSection[]> {
    const model = new ExternalLinkMenuItemModel();
    model.text = 'menu.section.policy';
    model.href = 'https://www.twc.edu.hk/en/Administration_Units/lib/institutionalrepository';

    return of([
      {
        visible: true,
        model,
        icon: 'scale-balanced',
      },
    ]);
  }
}
